//# sourceMappingURL=outline.mjs.map
/// <reference types="./outline.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $output from "../../../interfaces/schemas/outline/output.mjs";
import * as $assoc from "../../../tiamat/gleam/assoc.mjs";
import * as $json_ from "../../../tiamat/gleam/json_.mjs";
import * as $user_id from "../../data/auth/user_id.mjs";
import * as $data_point from "../../data/data_point.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $block from "../../data/proposal_element/block.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Outline extends $CustomType {
  constructor(id, owner, content, doc_id_order, proposal_id, qa_order, ai_processing, metadata, parent_id, updated_at, created_at) {
    super();
    this.id = id;
    this.owner = owner;
    this.content = content;
    this.doc_id_order = doc_id_order;
    this.proposal_id = proposal_id;
    this.qa_order = qa_order;
    this.ai_processing = ai_processing;
    this.metadata = metadata;
    this.parent_id = parent_id;
    this.updated_at = updated_at;
    this.created_at = created_at;
  }
}
export const Outline$Outline = (id, owner, content, doc_id_order, proposal_id, qa_order, ai_processing, metadata, parent_id, updated_at, created_at) =>
  new Outline(id,
  owner,
  content,
  doc_id_order,
  proposal_id,
  qa_order,
  ai_processing,
  metadata,
  parent_id,
  updated_at,
  created_at);
export const Outline$isOutline = (value) => value instanceof Outline;
export const Outline$Outline$id = (value) => value.id;
export const Outline$Outline$0 = (value) => value.id;
export const Outline$Outline$owner = (value) => value.owner;
export const Outline$Outline$1 = (value) => value.owner;
export const Outline$Outline$content = (value) => value.content;
export const Outline$Outline$2 = (value) => value.content;
export const Outline$Outline$doc_id_order = (value) => value.doc_id_order;
export const Outline$Outline$3 = (value) => value.doc_id_order;
export const Outline$Outline$proposal_id = (value) => value.proposal_id;
export const Outline$Outline$4 = (value) => value.proposal_id;
export const Outline$Outline$qa_order = (value) => value.qa_order;
export const Outline$Outline$5 = (value) => value.qa_order;
export const Outline$Outline$ai_processing = (value) => value.ai_processing;
export const Outline$Outline$6 = (value) => value.ai_processing;
export const Outline$Outline$metadata = (value) => value.metadata;
export const Outline$Outline$7 = (value) => value.metadata;
export const Outline$Outline$parent_id = (value) => value.parent_id;
export const Outline$Outline$8 = (value) => value.parent_id;
export const Outline$Outline$updated_at = (value) => value.updated_at;
export const Outline$Outline$9 = (value) => value.updated_at;
export const Outline$Outline$created_at = (value) => value.created_at;
export const Outline$Outline$10 = (value) => value.created_at;

export class Metadata extends $CustomType {
  constructor(item, block_parent_id, level, score, explanation, context_used) {
    super();
    this.item = item;
    this.block_parent_id = block_parent_id;
    this.level = level;
    this.score = score;
    this.explanation = explanation;
    this.context_used = context_used;
  }
}
export const Metadata$Metadata = (item, block_parent_id, level, score, explanation, context_used) =>
  new Metadata(item, block_parent_id, level, score, explanation, context_used);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$item = (value) => value.item;
export const Metadata$Metadata$0 = (value) => value.item;
export const Metadata$Metadata$block_parent_id = (value) =>
  value.block_parent_id;
export const Metadata$Metadata$1 = (value) => value.block_parent_id;
export const Metadata$Metadata$level = (value) => value.level;
export const Metadata$Metadata$2 = (value) => value.level;
export const Metadata$Metadata$score = (value) => value.score;
export const Metadata$Metadata$3 = (value) => value.score;
export const Metadata$Metadata$explanation = (value) => value.explanation;
export const Metadata$Metadata$4 = (value) => value.explanation;
export const Metadata$Metadata$context_used = (value) => value.context_used;
export const Metadata$Metadata$5 = (value) => value.context_used;

function metadata_decoder() {
  return $decode.field(
    "item",
    $output.outline_item_decoder(),
    (item) => {
      return $decrypt.optional_field(
        "block_parent_id",
        $decode.string,
        (block_parent_id) => {
          return $decode.optional_field(
            "level",
            0,
            $decode.int,
            (level) => {
              return $decrypt.optional_field(
                "score",
                $decrypt.float(),
                (score) => {
                  return $decrypt.optional_field(
                    "explanation",
                    $decode.string,
                    (explanation) => {
                      return $decrypt.optional_field(
                        "context_used",
                        $data_point.ids_decoder(),
                        (context_used) => {
                          let _block;
                          let _pipe = context_used;
                          _block = $option.unwrap(_pipe, toList([]));
                          let context_used$1 = _block;
                          return $decode.success(
                            new Metadata(
                              item,
                              block_parent_id,
                              level,
                              score,
                              explanation,
                              context_used$1,
                            ),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function outline_decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decrypt.optional_field(
        "owner",
        $user_id.decoder(),
        (owner) => {
          return $decode.field(
            "content",
            $decode.string,
            (content) => {
              return $decode.field(
                "doc_id_order",
                $decode.int,
                (doc_id_order) => {
                  return $decode.field(
                    "proposal_id",
                    $decode.string,
                    (proposal_id) => {
                      return $decode.field(
                        "qa_order",
                        $decode.int,
                        (qa_order) => {
                          return $decode.field(
                            "ai_processing",
                            $decode.bool,
                            (ai_processing) => {
                              return $decode.field(
                                "metadata",
                                $decrypt.json(metadata_decoder()),
                                (metadata) => {
                                  return $decrypt.optional_field(
                                    "parent_id",
                                    $decode.string,
                                    (parent_id) => {
                                      return $decrypt.optional_field(
                                        "created_at",
                                        $decrypt.timestamp(),
                                        (created_at) => {
                                          let created_at$1 = $option.lazy_unwrap(
                                            created_at,
                                            $timestamp.system_time,
                                          );
                                          return $decrypt.optional_field(
                                            "updated_at",
                                            $decrypt.timestamp(),
                                            (updated_at) => {
                                              let updated_at$1 = $option.lazy_unwrap(
                                                updated_at,
                                                $timestamp.system_time,
                                              );
                                              return $decode.success(
                                                new Outline(
                                                  id,
                                                  owner,
                                                  content,
                                                  doc_id_order,
                                                  proposal_id,
                                                  qa_order,
                                                  ai_processing,
                                                  metadata,
                                                  parent_id,
                                                  updated_at$1,
                                                  created_at$1,
                                                ),
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode_metadata(metadata) {
  let _pipe = $json_.empty();
  let _pipe$1 = $json_.json(
    _pipe,
    "item",
    $output.outline_item_to_json(metadata.item),
  );
  let _pipe$2 = $json_.optional_string(
    _pipe$1,
    "block_parent_id",
    metadata.block_parent_id,
  );
  let _pipe$3 = $json_.int(_pipe$2, "level", metadata.level);
  let _pipe$4 = $json_.optional_float(_pipe$3, "score", metadata.score);
  let _pipe$5 = $json_.optional_string(
    _pipe$4,
    "explanation",
    metadata.explanation,
  );
  let _pipe$6 = $json_.json(
    _pipe$5,
    "context_used",
    $data_point.ids_encode(metadata.context_used),
  );
  return $json_.to_json(_pipe$6);
}

export function encode_outline(outline) {
  let _pipe = $json_.empty();
  let _pipe$1 = $json_.string(_pipe, "id", outline.id);
  let _pipe$2 = $json_.string(
    _pipe$1,
    "element_type",
    $kind.to_string(new $kind.Outline()),
  );
  let _pipe$3 = $json_.optional_string(
    _pipe$2,
    "owner",
    $option.map(outline.owner, $user_id.to_string),
  );
  let _pipe$4 = $json_.optional_string(_pipe$3, "parent_id", outline.parent_id);
  let _pipe$5 = $json_.string(_pipe$4, "content", outline.content);
  let _pipe$6 = $json_.string(_pipe$5, "proposal_id", outline.proposal_id);
  let _pipe$7 = $json_.int(_pipe$6, "doc_id_order", outline.doc_id_order);
  let _pipe$8 = $json_.int(_pipe$7, "qa_order", outline.qa_order);
  let _pipe$9 = $json_.bool(_pipe$8, "ai_processing", outline.ai_processing);
  let _pipe$10 = $json_.json(
    _pipe$9,
    "metadata",
    encode_metadata(outline.metadata),
  );
  let _pipe$11 = $json_.rfc3339(_pipe$10, "updated_at", outline.updated_at);
  let _pipe$12 = $json_.rfc3339(_pipe$11, "created_at", outline.created_at);
  return $json_.to_json(_pipe$12);
}

export function from_outline_item(item, proposal_id, level) {
  return new Outline(
    item.id,
    new None(),
    item.title,
    0,
    proposal_id,
    0,
    false,
    new Metadata(item, new None(), level, new None(), new None(), $assoc.new$()),
    item.parent_id,
    $timestamp.system_time(),
    $timestamp.system_time(),
  );
}

export function to_block(outline) {
  return new $block.Block(
    new $kind.Outline(),
    outline.id,
    outline.owner,
    outline.content,
    outline.doc_id_order,
    $block.empty_metadata(),
    outline.proposal_id,
    outline.qa_order,
    outline.ai_processing,
    outline.updated_at,
    outline.created_at,
  );
}
